import { useToast, TOAST_TYPES } from "../../contexts/ToastContext";
import { CheckCircle, XCircle, Warning, Info, X } from "@phosphor-icons/react";
import "./Toast.css";

/**
 * Toast notification component.
 * Automatically displays toasts from the ToastContext.
 * Place this component once at the root level (e.g., in App.js or DashboardLayout).
 */
function Toast() {
  const { toasts, removeToast } = useToast();

  // Get icon based on toast type
  const getIcon = (type) => {
    switch (type) {
      case TOAST_TYPES.SUCCESS:
        return <CheckCircle size={20} weight="fill" />;
      case TOAST_TYPES.ERROR:
        return <XCircle size={20} weight="fill" />;
      case TOAST_TYPES.WARNING:
        return <Warning size={20} weight="fill" />;
      case TOAST_TYPES.INFO:
        return <Info size={20} weight="fill" />;
      default:
        return <CheckCircle size={20} weight="fill" />;
    }
  };

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-container" role="region" aria-label="התראות">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
          role="alert"
          aria-live="polite"
        >
          <div className="toast-icon">{getIcon(toast.type)}</div>
          <div className="toast-message">{toast.message}</div>
          <button
            className="toast-close"
            onClick={() => removeToast(toast.id)}
            aria-label="סגור התראה"
          >
            <X size={16} weight="bold" />
          </button>
        </div>
      ))}
    </div>
  );
}

export default Toast;
